class RiveAnimationRange {
	constructor() {

		this.items = document.querySelectorAll('.range-item');

		if( this.items.length === 0 ){
			return;
		}

		this.riveFileSource = mcubeArgs.themeLink + "/rive/smartto-tarifs.riv";
		fetch(this.riveFileSource)
		.then(response => {
			response.arrayBuffer().then(data => {
				this.riveFile = new Uint8Array(data);
				this.resizedAnimations = [];
				this.initRangeAnimation();
			});
		});
	}

	initRangeAnimation(){

		// let items = document.querySelectorAll('.range-item');

		this.items.forEach( (item) => {

			let rives = item.querySelectorAll('.rive-range');
			let navs = item.querySelectorAll('.switch-power span');

			rives.forEach( (el, i) => {

				el.innerHTML = `<canvas class="rive"></canvas>`;
				el.canvas = el.querySelector("canvas");
				this.setCanvasSize(el);

				el.animation = new rive.Rive({
					buffer: this.riveFile,
					artboard: "solar-pannels",
					canvas: el.canvas,
					autoplay: false,
					layout: new rive.Layout({
						fit: rive.Fit.Contain
					}),
					onLoad: (_) => {

						gsap.to(el.canvas, {
							opacity : 1,
							onComplete: () => {
								navs.forEach( (nav) => {
									if( nav.classList.contains('current') ){
										el.start = 0;
										el.end = nav.dataset.pannel;
										this.addPannelAnimation(el);
									}
									nav.addEventListener('click', () => {
										if( parseInt(nav.dataset.pannel) > parseInt(el.end) ){
											el.end = nav.dataset.pannel;
											this.addPannelAnimation(el);
										}else if( parseInt(nav.dataset.pannel) < parseInt(el.end) ){
											el.end = nav.dataset.pannel;
											this.removePannelAnimation(el);
										}
									});
								});
							}
						});

					}
				});
				this.resizedAnimations.push(el);
			});

		});

	}

	addPannelAnimation(el){
		if (el.start < el.end) {
			el.start++;
			el.animation.play(`panneau-${el.start}-appear`);
			el.interval = setTimeout( () => { this.addPannelAnimation(el); }, 80);
		}else{
			clearTimeout(el.interval);
		}
	}

	removePannelAnimation(el){
		if (el.start > el.end) {
			el.animation.play(`panneau-${el.start}-disappear`);
			el.start--;
			el.interval = setTimeout( () => { this.removePannelAnimation(el); }, 100);
		}else{
			clearTimeout(el.interval);
		}
	}

	setCanvasSize(parent) {
		parent.canvas.setAttribute("width", parent.clientWidth * Math.min(window.devicePixelRatio, 2));
		parent.canvas.setAttribute("height", parent.clientHeight * Math.min(window.devicePixelRatio, 2));
	}

	resize() {
		this.resizedAnimations.forEach(element => {
			this.setCanvasSize(element);
			element.animation.layout = new rive.Layout({fit: rive.Fit.Contain});
		});
	}
}
